import { useState } from 'react';
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import { LoginLayout } from './components/LoginLayout';
import PasswordField from './components/PasswordField';
import PasswordVerification from './components/PasswordVerification';
import Input from "components/Input/Input";
import Button from "components/Button/Button";
import { checkThePassword } from 'constants/index';

const MyForgotPassword = ({ onNavigate }) => {
  const [error, setError] = useState('');
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [passwordCheck, setPasswordCheck] = useState('');
  const [delivery, setDelivery] = useState(null);

  const handleSendPass = async (event) => {
    event.preventDefault();
    setError('');
    try {
      if (!delivery) {
        const output = await resetPassword({ username });
        setDelivery(output.nextStep);
      } else {
        if (password !== passwordCheck) {
          setError('Your passwords do not match each other');
          return;
        }
        await confirmResetPassword({ username, confirmationCode: code, newPassword: password });
        onNavigate('signIn');
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
    }
  };

  const passwordChecks = checkThePassword(password);
  const isPasswordValid = Object.values(passwordChecks).every(Boolean);
  const isSubmitDisabled = delivery && (!isPasswordValid || password !== passwordCheck);

  return (
    <LoginLayout title={"Reset Your Password"} errorMessage={error}>
      <form className="relative space-y-6 pt-4 pb-8" onSubmit={handleSendPass}>
        {
          !delivery && (
            <div className='px-8'>
              <Input
                label="Email Address"
                isMediumFont={true}
                id="username"
                name="username"
                required={true}
                onChange={(ev) => {
                  setError('');
                  setUsername(ev.target.value);
                }}
              />
            </div>
          )
        }
        {
          delivery && (
            <>
              <div className='px-8 space-y-6 pb-4 border-b border-b-border'>
                <Input
                  label="Verification Code"
                  isMediumFont={true}
                  id="code"
                  name="code"
                  inputProps={{
                    key: 'code',
                    name: 'code',
                  }}
                  onFocus={(ev) => ev.target.removeAttribute('readOnly')}
                  readOnly={true}
                  required={true}
                  onChange={(ev) => {
                    setError('');
                    setCode(ev.target.value);
                  }}
                />
                <p className='text-foreground text-sm'>
                  Enter the security code we just sent to your email address. The codes expire after 24 hours.
                </p>
              </div>
              <div className='px-8 space-y-6'>
                <PasswordField
                  defaulValue={''}
                  onChange={(ev) => {
                    setError('');
                    setPassword(ev.target.value);
                  }}
                  id="password"
                  name="password"
                  label="New Password"
                />
                <PasswordField
                  defaulValue={''}
                  onChange={(ev) => {
                    setError('');
                    setPasswordCheck(ev.target.value);
                  }}
                  id="password-check"
                  name="password-check"
                  label="Retype New Password"
                />
                <PasswordVerification
                  password={password || ''}
                  areEqual={password === passwordCheck && password !== '' && passwordCheck !== ''}
                />
              </div>
            </>
          )
        }
        <div className='px-8 space-y-6'>
          <Button
            type="submit"
            variant="primary"
            size="lg"
            isFullWidth={true}
            isTextCenter={true}
            loading={false}
            disabled={isSubmitDisabled}
          >
            {delivery ? 'Submit' : 'Send Verification'}
          </Button>
          <div className='flex justify-center'>
            <button
              type='button'
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              onClick={() => {
                onNavigate('signIn');
                setDelivery(null);
              }}
            >
              Back to Log In
            </button>
          </div>
        </div>
      </form>
    </LoginLayout>
  );
};

export default MyForgotPassword;
